import { giphyLightCharcoal, giphyWhite, giphyDarkestGrey } from '@giphy/js-brand'
import React, { useEffect, useContext, useCallback } from 'react'
import styled from 'styled-components'
import { useKeyPress } from 'react-use'
import { CollectionContext } from 'shared/components/context/add-to-collections-manager'
import Breadcrumbs from './add-to-collection/breadcumbs'
import { IChannel } from 'shared/types/channel'

const Container = styled.div`
    display: flex;
    justify-content: space-between;
    color: ${giphyWhite};
    font-family: 'nexablack', sans-serif;
    border-bottom: 1px solid ${giphyLightCharcoal};
    padding: 13px 0px 13px 6px;
`

const TitleDiv = styled.div`
    display: flex;
    cursor: pointer;
`

const BackButtonContainer = styled.div`
    width: 25px;
    display: flex;
    align-items: center;
    margin-bottom: -4px;
`

const Title = styled.div<{ reduceWidth: boolean }>`
    box-sizing: border-box;
    font-size: 16px;
    flex-direction: row;
    display: flex;
    max-height: 23px;
    overflow: hidden;
    white-space: nowrap;
    max-width: ${({ reduceWidth }) => reduceWidth && `400px`};
    &:after {
        position: absolute;
        content: '';
        height: 23px;
        width: 19px;
        right: 59px;
        background: linear-gradient(to right, transparent 0%, ${giphyDarkestGrey} 100%);
    }
`
const CloseButton = styled.div`
    display: flex;
    box-sizing: border-box;
    justify-content: flex-end;
    cursor: pointer;
    width: 25px;
`
type Props = {
    title?: string
    onClose?: () => void
    onBack?: () => void
    channel?: IChannel
    parent?: string
}
const Header = ({ title, onClose = () => {}, onBack, channel, parent }: Props) => {
    const [isEscPressed] = useKeyPress((event: KeyboardEvent) => event.key === 'Esc' || event.key === 'Escape')
    const { isDragging, gif } = useContext(CollectionContext)
    useEffect(() => {
        if (isEscPressed) {
            onClose()
        }
    }, [isEscPressed])

    const Crumbs = useCallback(() => {
        if (channel) {
            return <Breadcrumbs showRoot numberOfCrumbs={gif ? 2 : 4} channel={channel} />
        }
        return <></>
    }, [])

    return (
        <Container>
            <TitleDiv>
                {onBack && (
                    <BackButtonContainer onClick={onBack}>
                        <div className={isDragging && !!parent ? `ss-redirect` : 'ss-navigateleft'} />
                    </BackButtonContainer>
                )}
                <Title reduceWidth={!!gif}>
                    {isDragging && !!parent ? `Move to ${parent}` : channel ? <Crumbs /> : title}
                </Title>
            </TitleDiv>
            <CloseButton onClick={onClose}>
                <div className="ss-delete" />
            </CloseButton>
        </Container>
    )
}

export default Header
